<template>
  <div class="portal-content--bread-crumbs bread-crumbs d-flex align-items-center" v-if="breadcrumb">
    <b-button class="crumb" variant="link" :to="breadcrumb.path">
      <font-awesome-icon
        class="mr-2"
        :icon="['far', 'arrow-left']"
      />{{ breadcrumb.text }}
    </b-button>
  </div>
</template>
<script>
export default {
  name: 'PortalBreadcrumb',
  computed: {
    breadcrumb() {
      return this.$route.meta.breadcrumbParent ?? null;
    },
  },
};
</script>
